import { useState } from "react";

import { useAppDispatch, login } from "./store";
import config from "./appconf";

import "./NameInput.css";
import { ProfileInfo } from "common/Info";

function NameInput() {
  const dispatch = useAppDispatch();
  const [name, setName] = useState("");

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    fetch(`${config.baseUrl}/api/v1/accounts`, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      body: JSON.stringify({
        name,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((res) => {
        if (res.status == 200) {
          res.json().then((data: ProfileInfo) => {
            dispatch(login(data));
          });
        } else {
          // TODO add better error handling
          console.error("failed to create account");
        }
      })
      .catch((err) => {
        console.log(`Failed logon request. Error:${err}`);
      });
  };

  return (
    <div className="nameInput">
      <form onSubmit={handleSubmit} className="form">
        <div className="center">
          <label>Enter name:</label>
        </div>
        <div className="center">
          <input
            type="text"
            className="textInput"
            maxLength={20}
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          ></input>
        </div>
        <div className="center">
          <input type="submit" className="loginButton" value="login" />
        </div>
      </form>
    </div>
  );
}

export default NameInput;
